import React from "react";
import {useSelector} from "react-redux";
import styles from "./MobileFilterButton.module.scss";
import mainFacetStyles from "../MainFacet/MainFacet.module.scss"
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";
import utdanningerIcon from "../../img/Ikoner_Utdanning_large.svg";
import laerestederIcon from "../../img/Ikoner_Læresteder_large.svg";
import artikkelIcon from "../../img/Ikoner_Artikkel-intervju_large.svg";
import yrkerIcon from "../../img/Ikoner_Yrker_large.svg";
import annetIcon from "../../img/Ikoner_Oppgaver-utdanningsvalg_large.svg";

const MobileFilterButton = (props) => {
    const {clickHandler, isActive} = props;
    const newFilterState = useSelector(state => state.newFilterReducer);
    const facets = newFilterState.facets;
    const activeMainFacetID = getActiveMainFacetID(newFilterState);

    let buttonText = "Filtrer";
    let icon;
    if (activeMainFacetID) {
        const activeMainFacet = facets[activeMainFacetID];
        buttonText = activeMainFacet.value + " (" + activeMainFacet.count + ")";
        switch (activeMainFacet.value) {
            case "Utdanninger":
                icon = utdanningerIcon;
                break;
            case "Verktøy":
                icon = annetIcon;
                break;
            case "Lærested":
                icon = laerestederIcon;
                break;
            case "Artikler":
                icon = artikkelIcon;
                break;
            case "Yrker":
                icon = yrkerIcon;
                break;
            default:
                icon = null;
                break;
        }


    }

    let myClass = `${styles.wrapper}`;
    if (isActive) {
        myClass += ` ${styles.active}`;
    }
    if (activeMainFacetID) {
        myClass += ` ${styles.hasfacet}`;
    }

    return (
        <div className={styles.external}>
            <button onClick={clickHandler} className={myClass} aria-controls="filters+">
                {icon &&
                    <img className={mainFacetStyles.icon} src={icon} alt={buttonText + " ikon"}/>
                }

                {buttonText}
            </button>
        </div>
    );

};

export default MobileFilterButton;
